// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ChartDot_regular__1VS4V,\n.ChartDot_normal__32W-C {\n  color: black;\n}\n\n.ChartDot_medium__-gT41 {\n  color: var(--sun-base);\n}\n\n.ChartDot_high__q8WjE {\n  color: var(--orange-base);\n}\n\n.ChartDot_highest__qch63 {\n  color: var(--pink-base);\n}\n", "",{"version":3,"sources":["webpack://node_modules/@energybox/react-ui-library/dist/components/ChartDot/ChartDot.module.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".regular,\n.normal {\n  color: black;\n}\n\n.medium {\n  color: var(--sun-base);\n}\n\n.high {\n  color: var(--orange-base);\n}\n\n.highest {\n  color: var(--pink-base);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"regular": "ChartDot_regular__1VS4V",
	"normal": "ChartDot_normal__32W-C",
	"medium": "ChartDot_medium__-gT41",
	"high": "ChartDot_high__q8WjE",
	"highest": "ChartDot_highest__qch63"
};
export default ___CSS_LOADER_EXPORT___;
